import { useAppSelector } from 'root/src/client/logic/helpers/useStore';
import isOidcAccountSelector from 'root/src/client/logic/auth/selectors/isOidcAccountSelector';
import { ChangePasswordPanel } from './ChangePasswordPanel';
import { EmailSettingsPanel } from './EmailSettingsPanel';
export const AccountPanel = () => {
    // The email is shown for everyone; changing it is only relevant for OIDC (social) accounts,
    // mirroring the legacy account settings gating.
    const isOidcAccount = useAppSelector(isOidcAccountSelector);
    return (<div className="space-y-8">
			<EmailSettingsPanel canChange={isOidcAccount}/>
			<ChangePasswordPanel />
		</div>);
};
